import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import ServicesCard from './Cards/ServicesCard'
import CustomButton from './styled/CustomButton'
import { Button } from '@mui/material'
import PostaReviewModal from '../modals/PostaReviewModal'
import { DirectionsRenderer, GoogleMap, Marker } from '@react-google-maps/api'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '70%',
  maxHeight: '95vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  backgroundColor: '#fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const JobDetailsModal = ({
  handleJobDetailsModalToggle,
  modalOpen = false,
  booking,
  setSelectedBooking,
  getStylistScheduledBookings,
}) => {
  React.useEffect(() => {
    // if (modalOpen) {
    calculateDirections()
    // }
  }, [])
  
  const user = JSON.parse(localStorage.getItem('user'))
  const [jobStatus, setJobStatus] = React.useState('Pending')
  const [isLoading, setIsLoading] = React.useState(false)
  const [directions, setDirections] = React.useState(null)
  const [togglePostaReviewModal, setTogglePostaReviewModal] = React.useState(
    false,
  )

  const handlePostaReviewModal = () => {
    if (modalOpen) {
      handleJobDetailsModalToggle(false)
    }
    setTogglePostaReviewModal(!togglePostaReviewModal)
  }

  const calculateDirections = async () => {
    const directionsService = new window.google.maps.DirectionsService()
    const results = directionsService.route(
      {
        origin: user.location,
        destination: booking?.address,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result)
        } else {
          console.error(`error fetching directions ${result}`)
        }
      },
    )
  }

  const handdleJobStart = async () => {
    setIsLoading(true)
    let response = await saveOrUpdateDataById('start-job', {
      user_id: booking?.user?.id,
      booking_id: booking?.id,
    })
    setIsLoading(false)
    if (response.success === true) {
      setSelectedBooking(response?.data)
      Swal.fire({
        icon: 'success',
        title: 'Job has been started.',
        timer: 2000,
        confirmButtonColor: '#2597F6',
      })
    }
  }

  const handleJobEnd = async () => {
    setIsLoading(true)
    let response = await saveOrUpdateDataById('complete-job', {
      user_id: booking?.user?.id,
      booking_id: booking?.id,
    })
    setIsLoading(false)
    if (response.success === true) {
      setSelectedBooking(response?.data)
      getStylistScheduledBookings()
      Swal.fire({
        icon: 'success',
        title: 'Job has been completed.',
        timer: 2000,
        confirmButtonColor: '#2597F6',
      })
    }
  }

  const jobStatusLabelBgColor = () => {
    if (booking?.status == 'pending') return '#00827F'
    else if (booking?.status == 'in-progress') return '#08C4BB'
    else if (booking?.status == 'complete') return '#03BF13'
  }

  return (
    <>
    <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={modalOpen}
        onClose={() => handleJobDetailsModalToggle(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="job-details-modal">
          <div className="text-center">
            <h3 className="service-modal-title color-primary fs-24 mb-3 font-weight-bold">
              Job Details
            </h3>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 text-center">
                <div className="job-Details-services-card">
                  <ServicesCard booking={booking} />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 text-center">
                <div className="text-center position-relative map-area pointer h-100 d-flex justify-content-center mt-3 mt-md-0">
                  <div
                    style={{
                      zIndex: 1,
                      backgroundColor: jobStatusLabelBgColor(),
                    }}
                    className="position-absolute top-0 w-100 text-center"
                  >
                    <p className="m-0 py-1 text-white fs-20">
                      {booking?.status === 'pending'
                        ? 'Pending'
                        : booking?.status === 'in-progress'
                        ? 'In Progress'
                        : 'Completed'}
                    </p>
                  </div>
                  <GoogleMap
                    mapContainerStyle={{
                      width: '100%',
                      height: '88%',
                    }}
                    center={{
                      lat: Number(booking?.latitude),
                      lng: Number(booking?.longitude),
                    }}
                    zoom={10}
                    options={{
                      fullscreenControl: false,
                      streetViewControl: false,
                      mapTypeControl: false,
                    }}
                  >
                    <Marker
                      position={{
                        lat: Number(booking?.latitude),
                        lng: Number(booking?.longitude),
                      }}
                      opacity={1}
                      visible={true}
                      zIndex={99999}
                    ></Marker>
                    <Marker
                      position={{
                        lat: Number(user?.latitude),
                        lng: Number(user?.longitude),
                      }}
                      opacity={1}
                      visible={true}
                      zIndex={99999}
                    ></Marker>
                    {/* {modalOpen && directions && ( */}
                    <DirectionsRenderer directions={directions} />
                    {/* )} */}
                  </GoogleMap>
                  {jobStatus === 'Pending' && user?.user_type !== 'client' && (
                    <p className="fs-24 text-black m-0 mt-3 font-weight-bold position-absolute bottom-0">
                      Go to the client's' location <br /> to start this job
                    </p>
                  )}
                  {jobStatus === 'Pending' && user?.user_type === 'client' && (
                    <p className="fs-24 text-black m-0 mt-3 font-weight-bold position-absolute bottom-0">
                      This job is not yet started by <br /> the service provider
                    </p>
                  )}
                </div>
              </div>
            </div>
            {booking?.status === 'pending' && user?.user_type === 'provider' && (
              <Button
                id="btn-primary-no-shadow"
                onClick={handdleJobStart}
                className="mt-4 px-5"
              >
                Start Job
              </Button>
            )}
            {booking?.status === 'in-progress' &&
              user?.user_type === 'provider' && (
                <Button
                  id="btn-primary-no-shadow"
                  onClick={handleJobEnd}
                  className="mt-4 px-5"
                >
                  End Job
                </Button>
              )}
            {booking?.status === 'complete' && (
              <div className="row mt-4">
                <div className="col-12 col-sm-12 col-md-6 mt-3 mt-md-0">
                  <Button
                    id="btn-primary-no-shadow"
                    disableElevation
                    className="pointer"
                    style={{ width: '230px' }}
                    onClick={handlePostaReviewModal}
                  >
                    Post a Review
                  </Button>
                </div>
                <div className="col-12 col-sm-12 col-md-6 mt-3 mt-md-0">
                  <CustomButton
                    title={'Report'}
                    fullWidth={false}
                    width={'230px'}
                    background={'red'}
                    borderRadius={'16px'}
                  />
                </div>
              </div>
            )}
          </div>
        </Box>
      </Modal>
      <PostaReviewModal
        handlePostaReviewModal={handlePostaReviewModal}
        togglePostaReviewModal={togglePostaReviewModal}
        userType="provider"
        booking={booking}
        body={{
          stylist_id: booking?.stylist?.id,
          user_id: booking?.user?.id,
          service_id: booking?.id,
        }}
      />
    </>
  )
}

export default JobDetailsModal
